/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
namespace dvs_ui {
   export class Privileges {
      public static readonly HOST_CONFIG_NETWORK: string = "Host.Config.Network";
   }
}